import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import './preHome.css';
import { motion } from "framer-motion";
import Vara from 'vara';

export default function PreHome() {

    const navigate = useNavigate();
    const [inProp, setInProp] = React.useState(false);

    useEffect(() => {
        const container = document.getElementById("PreHome-name");
        if (container) container.innerHTML = ""; // Clear any previous render
    
        new Vara(
            '#PreHome-name',
            'https://raw.githubusercontent.com/akzhy/Vara/master/fonts/Satisfy/SatisfySL.json',
            [{
                // text: "Welcome! Thanks for stopping by.",
                text: "Hey there, glad you're here!",
                y: 40,
                fromCurrentPosition: { y: false },
                duration: 2000
            }],
            {
                strokeWidth: 2,
                fontSize: 48,
                color: "#000",
                textAlign: "center",
                width: 400
            }
        );
    }, []);
    

    useEffect(() => {
        setInProp(true);
        const timer = setTimeout(() => {
            setInProp(false);
            setTimeout(() => {
                navigate('../home');
            }, 300);
        }, 2700);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <CSSTransition in={inProp} timeout={300} classNames="fade">
            <section className='PreHome'>
                <div id="PreHome-name" className="navbar-PreHome-name"></div>
            </section>
        </CSSTransition>
    );
}